import React from 'react';

type Props = {
  size: number;
};

export const AppQrCode = (props: Readonly<Props>) => {
  const { size } = props;
  return (
    <img
      alt="App Download QR Code"
      height={`${size}px`}
      src="/cep/assets/img/qrCodes/x4c_login_page.png"
      style={{
        borderRadius: '6px',
        boxShadow: '0px 2px 7px 0px #00000040',
        padding: '4px',
      }}
      width={`${size}px`}
    />
  );
};
